<div [@listAnimation]="(data || []).length" class="ratio-bar-widget-container">
    @for (item of data; track $index) {
        <div class="ratio-bar-header">
            {{ item.label }} <span class="text-xs mx-2 text-dark-400">{{ item.nameSuffix }}</span>
            @if (showInfo && item.info) {
                <mat-icon class="helper-icon" (click)="displayInfo(item.info)" fontSet="material-icons-outlined">help_outline</mat-icon>
            }
        </div>
        <div class="ratio-bar" (click)="showPopup(item.id, item.version)">
            @for (part of item.data; track $index) {
                <div
                    @scaleAnimation
                    class="ratio-bar-part"
                    [style.width.%]="part.label !== 'NO DATA' ? part.value : 100"
                    [style.background-color]="part.color"
                ></div>
            }
        </div>
        <div class="ratio-bar-text-container">
            @for (part of item.data; track part) {
                <div class="ratio-bar-part-text" [style.color]="part.color">
                    <div [style.background-color]="part.color" class="ratio-bar-dot"></div>
                    {{ part.label }}
                    @if (part.label !== 'NO DATA') {
                        <span>{{ part.count }}</span>
                    }
                </div>
            }
        </div>
    }
</div>
